import Card from '@mui/material/Card';

export default Card;
